import React from "react";
import Chip from '@mui/material/Chip';
import { typeColors } from '../colors/typeColor';

const Chips = ({ types }) => {

    
    return (
        <>
            {
                types.map((type, index) => {

                    console.log(typeColors[type.type.name])
                    return (
                        <Chip 
                            key={index} label={type.type.name} 
                            color="primary" 
                            style={{backgroundColor:typeColors[type.type.name]}} 
                        />
                    );
                })
            }
        </>
    );
}

export default Chips;